import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import CPPaging from '@components/ClientPortal/CPPaging';
import LoadingMask from '@components/Share/LoadingMask';
import { deepCopy } from '@utils/utility';

import CPPageHeader from '../CPPageHeader';
import SaleOrdersListingModel from './Models/SaleOrdersListingModel';
import OrdersListing from './OrdersListing';
import OrdersSearch from './OrdersSearch';

const SaleOrdersListing = ({ fields }) => {
  const countData = useSelector((state) => state?.getSOCartsReducer?.dataApi?.Count);
  const ordersListing = useSelector((state) => state?.getSOCartsReducer?.dataApi?.Carts);
  const isGettingData = useSelector((state) => state?.getSOCartsReducer?.isLoading);
  const [layoutData, setLayoutData] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [keywordSearch, setKeywordSearch] = useState('');
  const [dataFilter, setDataFilter] = useState('');
  const [itemSkip, setItemSkip] = useState(0);
  const LEAD_MANAGEMENT_PAGESZ = 10;

  const filterSubmit = (evt, dateFilter, rangeData, statusSelected) => {
    evt.preventDefault();

    setDataFilter({
      dateFilter: dateFilter,
      rangeData: rangeData,
      statusSelected: statusSelected
    });

    setIsFilter(true);
  };

  const searchOrdersListing = (searchResult) => {
    if (searchResult == '') {
      setIsSearch(false);
    } else {
      setIsSearch(true);
    }

    setKeywordSearch(searchResult);
  };

  const changePageHandler = (pageNumber) => {
    setItemSkip((pageNumber - 1) * 10);
  };

  useEffect(() => {
    setLayoutData(new SaleOrdersListingModel().getData(deepCopy(fields)));
  }, []);

  return layoutData ? (
    <>
      <CPPageHeader
        title={layoutData?.Header?.value.replace('[Staff]', 'Test')}
        type='filter-orders'
        filterFields={layoutData}
        onFilterSubmit={filterSubmit}
        onSetIsReset={setIsReset}
      />
      <OrdersSearch onLayoutData={layoutData} onSearchOrdersListing={searchOrdersListing} />
      <OrdersListing
        onLayoutData={layoutData}
        onIsSearch={isSearch}
        onIsFilter={isFilter}
        onIsReset={isReset}
        onKeywordSearch={keywordSearch}
        onDataFilter={dataFilter}
        onSearchOrdersListing={searchOrdersListing}
        onOrdersListing={ordersListing}
        onItemSkip={itemSkip}
      />
      <CPPaging isReset={''} itemPerPage={LEAD_MANAGEMENT_PAGESZ} totalItem={countData} onChangePageHandler={changePageHandler} />
      {isGettingData ? <LoadingMask /> : <></>}
    </>
  ) : (
    <></>
  );
};

SaleOrdersListing.propTypes = {
  fields: PropTypes.any
};

export default SaleOrdersListing;
